<template>
  <div v-if="global">
    <v-progress-linear
      v-show="showGlobalLoader"
      class="ma-0 fp-loader"
      v-scroll="onScroll"
      indeterminate/>
  </div>
  <v-layout v-else
            align-center
            justify-center
            fill-height
            class="progress-wrapper ma-0"
            :style="{'min-height': size}">
    <v-flex shrink my-4 :style="{height: size, width: size}">
      <v-progress-circular
        v-if="circular"
        class="component-loader"
        ref="fpLoader"
        v-scroll="onScroll"
        indeterminate
        color="primary"/>
      <v-progress-linear
        v-else
        ref="fpLoader"
        v-scroll="onScroll"
        indeterminate
        color="primary"/>
    </v-flex>
  </v-layout>
</template>

<script>
import FpLoaderBus from '@/services/FpLoaderBus';
import {VFlex, VLayout, VProgressLinear} from 'vuetify/lib';

export default {
  name: 'FpLoader',
  components: {VLayout, VFlex, VProgressLinear,},
  props: {
    value: {
      default: true,
    },
    global: {
      default: false,
      type: Boolean,
    },
    circular: {
      default: false,
      type: Boolean,
    },
    size: {
      default: '50%',
      type: String,
    },
  },
  data() {
    return {
      showGlobalLoader: false,
      progressBarPosition: false,
    };
  },
  created() {
    FpLoaderBus.$on('loaderStateChange', (loaderState) => {
      this.$set(this, 'showGlobalLoader', loaderState);
    });
  },
  methods: {
    onScroll() {
      this.progressBarPosition = window.pageYOffset >= 60 || document.documentElement.scrollTop >= 60;
    },
  },
};
</script>

<style scoped lang="scss">
  .fp-loader{
    position: fixed;
    z-index: 999999999999999 !important;
    width: 100%;
    height: 8px;
    top: 0;
    margin: 0 !important;
    padding: 0 !important;
    &__circular {
      position: fixed;
      z-index: 999999999999999 !important;
      width: 10vh!important;
      height: 10vh!important;
      left: auto;
      right: auto;
      transition: .3s cubic-bezier(.25,.8,.5,1);
      top:  45vh;
      &:before {
        content: '';
        width: 100vw;
        position: fixed;
        height: 100vh;
        background: #212121;
        left: 0;
        transition: inherit;
        transition-delay: .15s;
        top: 0;
        opacity: .46;
      }
    }
  }
  .component-loader{
    height: 100% !important;
    width: 100%!important;
    z-index: 200;
  }
  .progress-wrapper {
    -webkit-border-radius: 12px;
    -moz-border-radius: 12px;
    border-radius: 12px;
    width: 100%;
    top: 0;
  }

</style>
